export default __webpack_public_path__ + "static/media/Cart_Icon.280f7186.svg";